<template>
  <el-dialog title="Gerar/Enviar por Email" :visible.sync="visibility" :before-close="cancelar" :close-on-click-modal="false" :modal-append-to-body="false" width="375px">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="">
            <el-select v-model="form.geracao" style="width:100%;">
                <el-option value="PDF"> 
                  <el-tooltip content="Temporariamente indisponível" placement="top">
                    <span>{{`Gerar Pdf`}}</span>
                  </el-tooltip>
                </el-option>
                <el-option label="Enviar por e-mail" value="E_MAIL"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="form.geracao == 'E_MAIL'">
        <el-col :span="24">
          <el-form-item label="E-mail">
            <el-input v-model="form.email" auto-complete="off"/>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="fechar" type="primary" size="small" v-if="form.geracao == 'PDF'" round class="btn-box-shadow">Gerar</el-button>
      <el-button @click="fechar" type="primary" size="small" v-if="form.geracao == 'E_MAIL'" round class="btn-box-shadow">Enviar</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visibility: Boolean,
    vistoria: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        form: {
            geracao: "PDF",
            email: ""
        }
    }
  },
  computed:{
    isVistoria(){
      this.alterarForm()
      return this.vistoria
    }
  },
  methods: {
    alterarForm(){
      this.vistoria ? this.form.geracao = "E_MAIL" : ""
    },
    fechar() {
      this.$emit('close', this.form);
    },
    cancelar() {
      this.$emit('close');
    }
  }
}
</script>
